import { apiClient } from "../config/api.config";
import { ManagerUpdate } from "../types/manager.definition";
export function getManagerById(managerId: string) {
  return apiClient.request({
    method: "get",
    url: `/managers/${managerId}`,
  });
}
export function updateManager(managerId: string, data: Partial<ManagerUpdate>) {
  return apiClient.request({
    method: "put",
    url: `/managers/${managerId}`,
    data,
  });
}
export function getManagerAvailabilities(managerId: string) {
  return apiClient.request({
    method: "get",
    url: `/manager-availability/${managerId}`,
  });
}

/**
 * Resend temporary password (Manager Only)
 * POST /api/v1/managers/staff/{userId}/resend-temporary-password
 */
export function resendTemporaryPassword(userId: string) {
  return apiClient.request({
    method: "post",
    url: `/managers/staff/${userId}/resend-temporary-password`,
  });
}
